import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5438_9745)">
      <circle cx="12" cy="12" r="12" fill="#A36EFE" />
      <g clip-path="url(#clip1_5438_9745)">
        <path
          d="M6.33591 13.5711L6.40044 14.7466C6.40466 14.8267 6.43467 14.902 6.48531 14.9637C6.83927 15.3923 8.42623 16.8875 12.0024 16.8875C15.5787 16.8875 17.1464 15.4116 17.5135 14.9717C17.5688 14.9053 17.6007 14.8229 17.6059 14.7363L17.6698 13.5719C18.0956 13.3383 18.5351 13.0743 18.5351 13.0743C19.2262 12.7 19.9974 13.2378 19.9988 14.0266C20.0011 15.3028 19.0039 16.6143 17.6589 17.4408C16.1422 18.3728 13.8783 18.7594 12.0034 18.7594C10.1286 18.7594 7.86463 18.3728 6.34798 17.4408C5.00291 16.6143 4.00572 15.3033 4.00806 14.0266C4.00947 13.2378 4.78069 12.7 5.47173 13.0743C5.47173 13.0743 5.9105 13.3377 6.33591 13.5711Z"
          fill="#4C2896"
        />
        <path
          d="M12.0029 5.22913C14.9269 5.22913 15.7197 5.29741 16.9087 5.43398H16.9082C17.4563 5.49708 17.8956 5.90491 17.8548 6.45731L17.4168 12.4232C17.2798 12.4629 17.1303 12.5131 16.9627 12.5693C16.0843 12.8641 14.7072 13.3263 12.0029 13.3263C9.29853 13.3263 7.92146 12.8641 7.043 12.5693C6.87523 12.513 6.72563 12.4628 6.58847 12.4231L6.15053 6.45731C6.11021 5.90491 6.54809 5.48719 7.09708 5.43398C8.27149 5.32001 9.4942 5.22913 12.0029 5.22913ZM6.79831 15.2818L6.79985 15.3027L6.83007 15.3097C6.81926 15.3003 6.80868 15.291 6.79831 15.2818ZM17.1782 15.309L17.2055 15.3027L17.2069 15.2837C17.1975 15.292 17.1879 15.3005 17.1782 15.309Z"
          fill="#4C2896"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5438_9745">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_5438_9745">
        <rect
          width="16"
          height="13.5463"
          fill="white"
          transform="translate(4 5.22681)"
        />
      </clipPath>
    </defs>
  </svg>
)
